/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookmarkFill: {
  name: 'bookmark-fill';
  data: string;
} = {
  name: 'bookmark-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 .5A1.5 1.5 0 0 0 1.5 2v11.538a1.5 1.5 0 0 0 2.044 1.398l4.275-1.662a.5.5 0 0 1 .362 0l4.275 1.662a1.5 1.5 0 0 0 2.044-1.398V2A1.5 1.5 0 0 0 13 .5H3Z" fill="currentColor"/></svg>`,
};
